import { render, staticRenderFns } from "./FixationAgents.vue?vue&type=template&id=f5971d50&scoped=true"
import script from "./FixationAgents.vue?vue&type=script&lang=js"
export * from "./FixationAgents.vue?vue&type=script&lang=js"
import style0 from "./FixationAgents.vue?vue&type=style&index=0&id=f5971d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5971d50",
  null
  
)

export default component.exports